import "@/App.css";
import MarconiApp from "@/pages/MarconiApp";

function App() {
  return (
    <div className="App">
      <MarconiApp />
    </div>
  );
}

export default App;
